// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1sbPa","title":"AfterFrontImage_title__23voK"};